import React from 'react';
import moment from 'moment';
import FontAwesome from 'react-fontawesome';
import * as MaterialUI from 'material-ui';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import { Row, Col, Container } from 'reactstrap';

import { GMapsC } from 'modules/general/component';
import { pickAColor } from 'core/generalFunctions';

moment.locale('es');
moment.updateLocale('es', {
  calendar: {
    nextDay: '[Mañana]',
    lastDay: '[Ayer]',
    sameDay: '[Hoy]',
  },
});

@connect()
export default class extends React.Component {
  reservasLink = (viajeId) => this.props.dispatch(push('/dashboard/reservas/pasajeros/' + viajeId));
  add = (viajeId) => this.props.dispatch(push('/dashboard/reservas/add/new/' + viajeId));
  render() {
    let ejecutado = false;
    const { viaje } = this.props,
      lastUpdate = viaje.getIn(['_localizacion', 0, 'fechaEnviado']),
      styleUpdateIcon = !lastUpdate
        ? 'iconAlert black'
        : 'iconAlert '.concat(
            moment().isBetween(moment(lastUpdate), moment(lastUpdate).add(5, 'minutes')) ? 'green' : moment().isBetween(moment(lastUpdate), moment(lastUpdate).add(15, 'minutes')) ? 'yellow' : 'red',
          ),
      showDataCombi = viaje && moment(viaje.get('horario')).isSame(moment(), 'day'),
      trayectoColor = pickAColor(viaje.get('trayectoId')),
      viajeUbicacion = viaje && viaje.getIn(['_localizacion', 0, 'ubicacion']) && viaje.getIn(['_localizacion', 0, 'ubicacion']).toJS(),
      ultimaConexion = viaje && viaje.getIn(['_localizacion', 0, 'fechaEnviado']);
    return (
      <div>
        <MaterialUI.ListItem
          className="noMargin"
          onTouchTap={() => !ejecutado && this.reservasLink(viaje.get('id'))}
          primaryText={
            <Row style={{ padding: 0 }}>
              <Col md="2" className="textCenter">
                <Container fluid className="pb-10">
                  <FontAwesome name="bus" className="iconInfo" style={{ color: trayectoColor }} />
                  {!viaje.get('publico') && <FontAwesome name="users" className="iconInfo" style={{ color: trayectoColor, paddingLeft: 5 }} />}
                  {viaje.get('rutinaId') && <FontAwesome name="calendar" className="iconInfo" style={{ color: trayectoColor, paddingLeft: 5 }} />}
                </Container>
                <Container
                  fluid
                  className={viaje.get('cantAsientosDisponibles') <= 0 ? 'unavailable' : this.props.manana ? 'available bg-2' : 'available'}
                  style={viaje.get('cantAsientosDisponibles') > 0 ? { backgroundColor: pickAColor(viaje.get('trayectoId')) } : {}}
                >
                  <FontAwesome name={viaje.get('cantReservas') > 10 ? 'users' : 'user'} /> {viaje.get('cantReservas') ? viaje.get('cantReservas') : 0} / {viaje.get('cantAsientos')}
                </Container>
              </Col>
              <Col md="8">
                <Row>
                  <Col md="5" xs="4">
                    <Row>
                      <Col md="12" className="pb-10">
                        <FontAwesome name="clock-o" style={{ color: trayectoColor }} />
                        {' ' + moment(viaje.get('horario')).format('HH:mm')}
                        <FontAwesome name="calendar" style={{ color: trayectoColor, paddingLeft: '20px' }} />
                        {' ' + moment(viaje.get('horario')).format('DD/MM')}
                      </Col>
                      <Col md="12">
                        <p style={{ color: pickAColor(viaje.get('trayectoId')) }}>
                          {viaje.getIn(['_trayecto', 'nombre'])} {viaje.getIn(['_trayecto', 'subnombre']) && ' - ' + viaje.getIn(['_trayecto', 'subnombre'])}
                        </p>
                      </Col>
                    </Row>
                  </Col>
                  <Col md="5" xs="4">
                    {showDataCombi && viaje && moment().isAfter(moment(viaje.get('horario'))) && !viaje.getIn(['_localizacion', 0, 'ubicacion']) && (
                      <FontAwesome name="warning" className="iconAlert" />
                    )}
                    {viajeUbicacion && <FontAwesome name="warning" className="map-marker" />}
                  </Col>
                </Row>
              </Col>
              <Col md="2">
                <MaterialUI.MenuItem
                  className="textCenter"
                  style={{ width: '100%', height: '100%' }}
                  onTouchTap={(event) => {
                    ejecutado = true;
                    event.preventDefault();
                    this.add(viaje.get('id'));
                    return false;
                  }}
                  disabled={!viaje.get('reservable') || viaje.get('cantAsientosDisponibles') <= 0}
                >
                  <FontAwesome name={viaje.get('reservable') ? 'ticket' : 'eye'} style={{ color: trayectoColor, fontSize: '40px' }} />
                </MaterialUI.MenuItem>
              </Col>
            </Row>
          }
        />
        <MaterialUI.Divider />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/modules/viajes/components/itemList.js